import Group from '@/components/_common/Group';
import { Form, Tag } from 'antd';
import { useLabelPrintingContext } from '../..';
import { LabelPrintingLayoutPresetKey, layout_presets } from '../presets';

export default function LabelPrintingToolbarPresetsPanel() {
  const { form } = useLabelPrintingContext();

  const presets = Object.keys(layout_presets);

  const presetChecked = Form.useWatch('preset', form);

  const handleChangePreset = (preset: LabelPrintingLayoutPresetKey) => {
    const presetFind = layout_presets[preset];
    form?.setFieldsValue({
      preset,
      layout: {
        ...presetFind,
        orientation: presetFind.orientation ?? undefined,
      },
    });
  };

  return (
    <>
      <Form.Item hidden name="preset" />

      <Group style={{ flexWrap: 'wrap' }} gap={4}>
        {presets.map((preset) => (
          <Tag.CheckableTag
            checked={preset === presetChecked}
            key={preset}
            style={{
              padding: '6px 12px',
              border: '1px solid lightgray',
              margin: 0,
            }}
            onChange={(checked) => {
              if (checked) {
                handleChangePreset(preset as LabelPrintingLayoutPresetKey);
              }
            }}
          >
            {preset.toUpperCase()}
          </Tag.CheckableTag>
        ))}
      </Group>
    </>
  );
}
